import { AppRouter } from '@ca/api'
import { createTRPCReact, TRPCClientError } from '@trpc/react-query'
import { inferRouterInputs, inferRouterOutputs } from '@trpc/server'

export const trpc = createTRPCReact<AppRouter>()

export type TRPCAppError = TRPCClientError<AppRouter>

export function isTRPCClientError(cause: unknown): cause is TRPCAppError {
  return cause instanceof TRPCClientError
}

export type RouterOutputs = inferRouterOutputs<AppRouter>
export type RouterInputs = inferRouterInputs<AppRouter>
